// Centralized site URL — change this single constant when migrating domains.
export const SITE_URL = "https://transshift.com";
export const SITE_NAME = "TransShift";
